import { render, staticRenderFns } from "./ReplaceShippingLeadTime.vue?vue&type=template&id=1f65eff0&scoped=true&"
import script from "./ReplaceShippingLeadTime.vue?vue&type=script&lang=js&"
export * from "./ReplaceShippingLeadTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65eff0",
  null
  
)

export default component.exports